module.exports = __webpack_public_path__ + "img/icon_mouse.91d0ea18.svg";